import React from "react";

/**
 * El pie de las confirmaciones (`Modal.confirm`): el botón de volver en el extremo izquierdo y el
 * de confirmar en el derecho, en vez de los dos juntos a la derecha como los pone antd.
 *
 *   Modal.confirm({ ..., footer: confirmFooter })
 */
export const confirmFooter = (
  _: React.ReactNode,
  { OkBtn, CancelBtn }: { OkBtn: React.FC; CancelBtn: React.FC },
) => (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      paddingTop: 8,
    }}
  >
    <CancelBtn />
    <OkBtn />
  </div>
);
